export enum AccountActionId {
  WORKSPACE_SETTINGS = 'workspace_settings',
  BILLING = 'billing',
  ONBOARDING_SETUP = 'onboarding_setup',
  OPEN_HELP = 'open_help',
  DOCUMENTATION = 'documentation',
  LIVE_CHAT = 'live_chat',
  API_KEYS = 'api_keys',
  APPEARANCE = 'appearance',
  SIGN_OUT = 'sign_out',
}
export enum AccountActionSection {
  WORKSPACE = 'workspace',
  USER = 'user',
  HELP = 'help',
  DEVELOPER = 'developer',
}
export enum AccountActionKind {
  LINK = 'link',
  EXTERNAL_LINK = 'external_link',
  ACTION = 'action',
  APPEARANCE = 'appearance',
}
export enum AccountMenuSurface {
  DESKTOP_USER = 'desktop_user',
  DESKTOP_WORKSPACE = 'desktop_workspace',
  DESKTOP_HELP = 'desktop_help',
  DESKTOP_DEVELOPER = 'desktop_developer',
  DESKTOP_TOPBAR = 'desktop_topbar',
  MOBILE_MORE = 'mobile_more',
}
export enum AppearanceThemeId {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}
